import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { IconPicker, IconPickerItem } from 'react-fa-icon-picker';
import { useForm } from 'react-hook-form';
import { FaChevronLeft } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import SubmitBtn from '../../../../Components/Buttons/SubmitBtn';
import { FormGroup } from '../../../../Components/FormGroup/FormGroup';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';

function ThematicAreaForm() {
  const navigate = useNavigate();
  const { id, edit: isEdit } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue: setFormValue,
    formState: { errors }
  } = useForm({
    mode: 'onblur',
    defaultValues: {}
  });

  const [color, setColor] = useState('');
  const [value, setValue] = useState('');

  const handleColorChange = (colorCode) => {
    setColor(colorCode);
  };

  useEffect(() => {
    if (isEdit) {
      const getThematicArea = async () => {
        const test = await fetchWrapper.get(`/thematicarea/${id}/`);
        setFormValue('title_nepali', test.data.title_nepali);
        setFormValue('thematic_area_color', test.data.color);
        setFormValue('icon', test.data.color);
        setFormValue('description', test.data?.description);
      };
      getThematicArea();
    }
  }, []);

  const onSubmit = async (data) => {
    data = {
      // title_english: data?.title_english,
      title_nepali: data?.title_nepali,
      icon: value,
      color: data?.thematic_area_color,
      description: data.description
    };

    try {
      setIsLoading(true);
      if (isEdit) {
        await fetchWrapper.patch(`/thematicarea/${id}/`, data);
        toast.success(<FormattedMessage id="thematic_area.updated" />);
        navigate('/admin/settings/thematic_area');
      } else {
        await fetchWrapper.post('/thematicarea/', data);
        toast.success(<FormattedMessage id="thematic_area.created" />);
        navigate('/admin/settings/thematic_area');
      }

      setIsLoading(false);
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };
  return (
    <div className="card content-section p-3">
      <h4 className="text-primary">
        {isEdit ? <FormattedMessage id="edit" /> : <FormattedMessage id="add_new" />}
      </h4>
      <hr />
      <form onSubmit={handleSubmit(onSubmit)} className="ms-3">
        <div className="row">
          <div className="col-md-6">
            <FormattedMessage id="thematic_area_placeholder">
              {(placeholder) => (
                <FormGroup
                  id="title_nepali"
                  type="text"
                  placeholder={placeholder[0]}
                  register={register}
                  error={errors}
                  label="शीर्षक"
                  errorId={'thematic_area_title'}
                  required={true}
                />
              )}
            </FormattedMessage>

            <FormattedMessage id="description.placeholder">
              {(placeholder) => (
                <FormGroup
                  type="textarea"
                  placeholder={placeholder[0]}
                  register={register}
                  error={errors}
                  id="description"
                  label={<FormattedMessage id="description" />}
                  // required={true}
                  errorName="Title"
                />
              )}
            </FormattedMessage>
          </div>
          {/* <div className="col-md-6">
            <FormattedMessage id="thematic_area_placeholder">
              {(placeholder) => (
                <FormGroup
                  id="title_english"
                  type="text"
                  placeholder={placeholder[0]}
                  register={register}
                  error={errors}
                  label="Title in English"
                  errorId={'thematic_area_title'}
                  required={true}
                />
              )}
            </FormattedMessage>
          </div> */}
        </div>
        <div className="row my-4">
          <div className="col-md-4">
            <FormattedMessage id="icon" />
            <div>
              {}
              <IconPicker
                value={value}
                register={register}
                onChange={(v) => setValue(v)}
                // buttonStyles={{ padding: '5px', width: '100px', verticalAlign: 'none ' }}
                containerStyles={{ left: '1px', width: '1000px' }}
                // buttonIconStyles={{ fontSize: '100px', padding: 0, width: '100px' }}
                // pickerIconStyles={{ fontSize: '80px' }}
                //   searchInputStyles={{ height: '80px', fontSize: '40px' }}
                size={100}
              />
            </div>
          </div>
          <div className="col-md-4">
            <FormattedMessage id="select_icon_color" />
            <FormGroup
              type="color"
              register={register}
              id="thematic_area_color"
              onChange={(e) => handleColorChange(e.target.value)}
            />
          </div>

          <div className="col-md-4 ">
            <FormattedMessage id="preview" />
            <div className="d-flex">
              {value && (
                <IconPickerItem
                  icon={value}
                  size={70}
                  color={color}
                  containerStyles={{ padding: '0px 20px', border: value ? '1px solid black' : '' }}
                />
              )}
            </div>
          </div>
        </div>
        <hr />

        <div className="d-flex mt-3">
          <Button
            variant="secondary"
            onClick={() => {
              navigate(-1);
            }}>
            <FaChevronLeft />
            <FormattedMessage id="button.back" />
          </Button>
          <SubmitBtn isLoading={isLoading} />
        </div>
      </form>
    </div>
  );
}

export default ThematicAreaForm;
